import { tagsDiscovery } from '../api/tags'
import type { Resolvers } from '../generated/server/resolvers'

const Tag: Resolvers = {
  Query: {
    tagsDiscovery,
  },
}

export default Tag
